import { useTrackingQuery } from './use-tracking-query';
export function useEcommerceProcesses() {
  var _useTrackingQuery$dat, _useTrackingQuery$dat2;

  return (_useTrackingQuery$dat = (_useTrackingQuery$dat2 = useTrackingQuery().data) === null || _useTrackingQuery$dat2 === void 0 ? void 0 : _useTrackingQuery$dat2.ecommerceProcess.events) !== null && _useTrackingQuery$dat !== void 0 ? _useTrackingQuery$dat : [];
}